/**
 * Contractors Reducer
 * Initial state and action handler for contractors list
 */

const initialState = { data: [], loading: true };

export const GetAllContractorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_contractors":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

// Initial contractor data structure (for form default values)
export const contractorDataState = {
  ContractorId: 0,
  ContractorName: null,
  ContactPersonName: null,
  ContactEmail: null,
  ContactPhone: null,
  Address: null,
  City: null,
  Country: null,
  RegistrationNumber: null,
  Status: "Active",
};
